module.exports = __webpack_public_path__ + "static/img/236_TO8_1991.67a4557.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/236_TO8_1991.jpg
// module id = s8t9
// module chunks = 0